module.exports = __webpack_public_path__ + "media/images/talent/bg-conversion-501a60aabfefcad7656d521337ba3998.png";